import * as Yup from 'yup';


const schema = Yup.object().shape({
    "nome": Yup.string().required("Informe o nome"),
    "nomeUrl": Yup.string().required("Informe o nome da url"),
});

export default schema;